var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$hasPermission('requests.profiles.create'))?_c('button',{staticClass:"btn btn-link",on:{"click":_vm.create}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Создать")]):_vm._e(),_vm._v(" "),_vm._l((_vm.profiles),function(profile){return [_c('ProfileListItem',{attrs:{"profile_model":profile}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }